"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagePopup = void 0;
var dom_interact_1 = require("../../helpers/dom-interact");
var Types_1 = require("../../Modules/Types");
var basicSettingOfElements = (_a = {},
    _a[Types_1.MessagePopupElementIds.TITLE] = {
        tag: Types_1.MessagePopupElementTags.P,
        basicClassName: ['MessagePopup-title'],
    },
    _a[Types_1.MessagePopupElementIds.TEXT] = {
        tag: Types_1.MessagePopupElementTags.P,
        basicClassName: ['MessagePopup-text'],
    },
    _a[Types_1.MessagePopupElementIds.BUTTON] = {
        tag: Types_1.MessagePopupElementTags.LI,
        basicClassName: ['MessagePopup-button'],
    },
    _a[Types_1.MessagePopupElementIds.CLOSE_BUTTON] = {
        tag: Types_1.MessagePopupElementTags.SPAN,
        basicClassName: ['MessagePopup-closeBtn', 'without-text', 'with-icon', 'svg-close-window'],
    },
    _a[Types_1.MessagePopupElementIds.OVERLAY] = {
        tag: Types_1.MessagePopupElementTags.DIV,
        basicClassName: ['MessagePopup-overlay'],
    },
    _a);
var MessagePopup = /** @class */ (function () {
    function MessagePopup(el) {
        this.openClassName = 'is-open';
        this.disableClassName = 'is-disable';
        this.fixBodyClassName = 'is-fix-body-position';
        this.isOpen = false;
        this.rootElement = el;
        this.titleHolder = (0, dom_interact_1.getHTMLElement)(this.rootElement, '.js-mp-title-holder');
        this.contentHolder = (0, dom_interact_1.getHTMLElement)(this.rootElement, '.js-mp-content-holder');
        this.textHolder = (0, dom_interact_1.getHTMLElement)(this.rootElement, '.js-mp-text-holder');
        this.buttonHolder = (0, dom_interact_1.getHTMLElement)(this.rootElement, '.js-mp-button-holder');
        this.documentScrollPosition = 0;
        this.innerElementsList = [];
    }
    MessagePopup.prototype.openPopup = function (contentList) {
        this.deleteInnerElements();
        this.render(contentList);
        this.fixBodyPosition();
        this.rootElement.classList.add(this.openClassName);
        this.isOpen = true;
    };
    MessagePopup.prototype.closePopup = function () {
        if (!this.isOpen) {
            return;
        }
        this.rootElement.classList.remove(this.openClassName);
        this.unFixBodyPosition();
        this.deleteInnerElements();
        this.isOpen = false;
    };
    MessagePopup.prototype.disableInnerElements = function () {
        var _this = this;
        if (!this.isOpen) {
            return;
        }
        this.innerElementsList.forEach(function (elementSettings) {
            elementSettings.requiredClassNames = [_this.disableClassName];
            if (elementSettings.id === Types_1.MessagePopupElementIds.BUTTON) {
                _this.appendDecorativeElement(elementSettings);
            }
        });
    };
    MessagePopup.prototype.render = function (contentList) {
        var _this = this;
        contentList.forEach(function (content) {
            var elementSettings = _this.getElementSettings(content);
            _this.appendElement(elementSettings);
        });
    };
    MessagePopup.prototype.getElementSettings = function (content) {
        var settings = this.getDefaultSettings(document.createElement(basicSettingOfElements[content.id].tag));
        settings.requiredClassNames = __spreadArray([], basicSettingOfElements[content.id].basicClassName, true);
        Object.keys(content).forEach(function (key) { return (settings[key] = content[key]); });
        return settings;
    };
    MessagePopup.prototype.getDefaultSettings = function (element) {
        return Object.create({}, {
            id: {
                value: '',
                writable: true,
            },
            type: {
                value: '',
                writable: true,
            },
            element: {
                value: element,
                writable: true,
            },
            text: {
                set: function (value) {
                    this._text = value;
                    this.element.innerHTML = value;
                },
            },
            _classNames: {
                value: [],
                writable: true,
            },
            requiredClassNames: {
                set: function (value) {
                    this._classNames = __spreadArray(__spreadArray([], this._classNames, true), value, true);
                    this.element.setAttribute('class', this._classNames.join(' '));
                },
            },
            _handler: {
                value: function () { },
                writable: true,
            },
            handler: {
                set: function (value) {
                    this.element.removeEventListener('click', this._handler);
                    this._handler = function (event) {
                        value(event);
                    };
                    this.element.addEventListener('click', this._handler);
                },
            },
        });
    };
    MessagePopup.prototype.appendElement = function (elementSettings) {
        this.innerElementsList.push(elementSettings);
        switch (elementSettings.id) {
            case Types_1.MessagePopupElementIds.TITLE:
                this.titleHolder.appendChild(elementSettings.element);
                break;
            case Types_1.MessagePopupElementIds.TEXT:
                this.textHolder.appendChild(elementSettings.element);
                break;
            case Types_1.MessagePopupElementIds.BUTTON: {
                this.buttonHolder.appendChild(elementSettings.element);
                break;
            }
            case Types_1.MessagePopupElementIds.CLOSE_BUTTON:
                this.contentHolder.appendChild(elementSettings.element);
                break;
            case Types_1.MessagePopupElementIds.OVERLAY:
                this.rootElement.appendChild(elementSettings.element);
                break;
            default:
                break;
        }
    };
    MessagePopup.prototype.fixBodyPosition = function () {
        if (this.isOpen) {
            return;
        }
        this.documentScrollPosition = document.documentElement.scrollTop;
        var body = (0, dom_interact_1.getHTMLElement)(document, 'body');
        body.style.top = "".concat(-this.documentScrollPosition, "px");
        body.classList.add(this.fixBodyClassName);
    };
    MessagePopup.prototype.unFixBodyPosition = function () {
        var body = (0, dom_interact_1.getHTMLElement)(document, 'body');
        body.classList.remove(this.fixBodyClassName);
        body.style.top = 'auto';
        document.documentElement.scrollTop = this.documentScrollPosition;
    };
    MessagePopup.prototype.deleteInnerElements = function () {
        this.innerElementsList.forEach(function (elementSettings) {
            if (elementSettings.element.parentNode) {
                elementSettings.element.parentNode.removeChild(elementSettings.element);
            }
        });
        this.innerElementsList.length = 0;
    };
    MessagePopup.prototype.appendDecorativeElement = function (elementSettings) {
        var decorativeElement = document.createElement('span');
        decorativeElement.classList.add('MessagePopup-decorativeElement');
        elementSettings.element.appendChild(decorativeElement);
    };
    return MessagePopup;
}());
exports.MessagePopup = MessagePopup;
